import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import LockUnlockedIcon from '@atlaskit/icon/core/lock-unlocked';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import {
	LIMITED_ACCESS_LEVEL,
	OPEN_ACCESS_LEVEL,
	PRIVATE_ACCESS_LEVEL,
	type AccessLevel,
} from '@atlassian/jira-shared-types/src/project.tsx';

export const getAccessLevelIcon = (accessLevel?: AccessLevel) => {
	switch (accessLevel) {
		case PRIVATE_ACCESS_LEVEL:
			return LockLockedIcon;
		case LIMITED_ACCESS_LEVEL:
			return PeopleGroupIcon;
		case OPEN_ACCESS_LEVEL:
			return LockUnlockedIcon;
		default:
			return undefined;
	}
};

export const getAccessLevelIconFromIconName = (icon?: string) => {
	switch (icon) {
		case 'private':
			return getAccessLevelIcon(PRIVATE_ACCESS_LEVEL);
		case 'limited':
			return getAccessLevelIcon(LIMITED_ACCESS_LEVEL);
		case 'open':
			return getAccessLevelIcon(OPEN_ACCESS_LEVEL);
		default:
			return undefined;
	}
};
